import React, { forwardRef, useImperativeHandle, useRef } from "react";
import ReCAPTCHA from 'react-google-recaptcha';
import { showCaptchaErrorPopup } from './captchaPopup';

interface CaptchaProps {
    onVerify: (token: string | null) => void;
    onExpired?: () => void;
    onErrored?: () => void;
    className?: string;
}
const key  = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

if (!key) {
    console.error('REACT_APP_RECAPTCHA_SITE_KEY is not set - reCAPTCHA will fail to load.');
}

const Captcha = forwardRef<ReCAPTCHA, CaptchaProps>(({ onVerify, onExpired, onErrored, className }, ref) => {
    const recaptchaRef = useRef<ReCAPTCHA>(null);
    useImperativeHandle(ref, () => recaptchaRef.current as ReCAPTCHA);

    const handleExpired = () => {
        onVerify(null);
        if (onExpired) {
            onExpired();
        }
    };

    const handleErrored = () => {
        onVerify(null);
        if (onErrored) {
            onErrored();
        } else {
            showCaptchaErrorPopup(() => recaptchaRef.current?.reset());
        }
    };

    return (
        <div className={className}>
            <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={key || ""}
                onChange={onVerify}
                onExpired={handleExpired}
                onErrored={handleErrored}
            />
        </div>
    );
});

Captcha.displayName = 'Captcha';

export default Captcha;
